module.exports = __webpack_public_path__ + "index_pc/img/b3.b071becb.png";